import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { get } from 'lodash';

import { checkinAction } from 'actions/workflow';
import { TextPhone } from 'components/Icons';
import { BackButton, Button } from 'components/Button';
import { FormRow } from 'components/Form';
import GeneralError from 'components/GeneralError';
import useWorkflowGuard from 'hooks/useWorkflowGuard';
import { SEND_TEXT_COOLDOWN_SECONDS } from 'utils/constants';

const CheckYourPhone = ({
  navigate,
  dispatch,
  searchParams,
}) => {
  useWorkflowGuard(searchParams, navigate);
  const [isSendingText, setIsSendingText] = useState(false);
  const [cooldownSeconds, setCooldownSeconds] = useState(SEND_TEXT_COOLDOWN_SECONDS);
  const [generalError, setGeneralError] = useState(null);
  const mobileNumberLastFour = useSelector((state) => get(state, 'workflow.data.mobileNumberLastFour'));

  useEffect(() => {
    if (cooldownSeconds > 0) {
      const timer = setTimeout(() => setCooldownSeconds(cooldownSeconds - 1), 1000);
      return () => clearTimeout(timer);
    }
  }, [cooldownSeconds]);

  const resendText = (e) => {
    e.preventDefault();
    setIsSendingText(true);

    dispatch(checkinAction({
      key: searchParams.get('key'),
      data: {
        resendText: true,
      },
      success: () => {
        setIsSendingText(false);
        setCooldownSeconds(SEND_TEXT_COOLDOWN_SECONDS);
      },
      fail: handleGeneralFail,
    }));
  };

  const handleGeneralFail = (err) => {
    setGeneralError(get(err, 'data.failure.errors.0'));
    setIsSendingText(false);
  }

  return (
    <div className="flex flex-col items-center text-center gap-8 relative">
      <div className="mt-4">
        <TextPhone className="mx-auto mb-4" />
        <p className="text-3xl font-semibold text-slate-800">
          Please Check <br />Your Phone
        </p>
      </div>
      <div>
        <p className="text-gray-600 font-semibold mb-2">
          A text message has been sent to (***) ***-{mobileNumberLastFour} to proceed with your loan.
        </p>
        <p className="text-sm text-gray-500">
          Use the secure link in your text message to scan your government-issued ID and continue your application.
        </p>
      </div>

      <GeneralError error={generalError} />

      <FormRow className="w-full flex-col-reverse">
        <BackButton
          className="flex-1"
          onBeforeBack={() => setGeneralError(null)}
          onFail={handleGeneralFail}
        />
        <Button
          className="flex-1"
          label={cooldownSeconds > 0 ? `Resend Text (${cooldownSeconds}s)` : 'Resend Text'}
          isLoading={isSendingText}
          onClick={resendText}
          isDisabled={cooldownSeconds > 0}
        />
      </FormRow>
    </div>
  );
};

CheckYourPhone.propTypes = {
  navigate: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  searchParams: PropTypes.object.isRequired,
};

export default CheckYourPhone;
